<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Authors</Modal.Title>
    <Modal.Body>
      <FileAuthorsBody :file="file" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import FileAuthorsBody from './FileAuthorsBody.vue'

defineProps<{
  file: File
}>()
</script>
